import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { VehicleSchematic } from './VehicleSchematic';
import { IntrusionLog } from './IntrusionLog';
export function ThreatConsole() {
  return <motion.div initial={{
    opacity: 0,
    scale: 0.96,
    y: 12
  }} animate={{
    opacity: 1,
    scale: 1,
    y: 0
  }} transition={{
    duration: 0.3,
    ease: [0.23, 1, 0.32, 1],
    delay: 0.12
  }} className="relative mx-auto w-full max-w-[540px]" data-id="element-58" data-mp="1xkasngw4vdkw">
      <div className="shadow-panel flex h-[448px] flex-col rounded-2xl border border-line bg-surface px-5 py-[18px]" data-id="element-59" data-mp="2v68hdw13wf5a">
        <div className="mb-3 flex items-center justify-between" data-id="element-60" data-mp="2gidnwdf9y6r5">
          <h2 className="flex items-center gap-2 text-[13px] font-bold text-heading" data-id="element-61" data-mp="2lgoywrhb2nay">
            <span aria-hidden="true" className="h-2 w-2 rounded-full bg-secure" data-id="element-62" data-mp="2lec77mlqwykp" />
            Live Threat Monitor
          </h2>
          <span className="rounded-full border border-line px-2.5 py-[3px] text-[10.5px] text-muted" data-id="element-63" data-mp="3dxj6c7n9uhuj">
            Fleet-wide · Vehicle #0417
          </span>
        </div>

        <VehicleSchematic data-id="element-64" data-mp="29890zau8qqmn" />
        <div className="mt-3 flex flex-1 flex-col" data-id="element-65" data-mp="24c0qwbuwhnmc">
          <IntrusionLog data-id="element-66" data-mp="24dbuaakfotcx" />
        </div>
      </div>

      <div className="shadow-float absolute -bottom-6 left-6 z-10 w-[210px] rounded-xl border border-line bg-surface px-3.5 py-[11px]" data-id="element-67" data-mp="2j0wtvui3oag3">
        <p className="flex items-center gap-1.5 text-[11.5px] font-bold text-heading" data-id="element-68" data-mp="2e83ulm5ehube">
          <ShieldCheckIcon className="h-3.5 w-3.5 text-accent-ink" aria-hidden="true" data-id="element-69" data-mp="2rzs21c4pfum1" />
          5 / 6 ECUs verified
        </p>
        <p className="mt-1 text-[10.5px] font-semibold text-secure" data-id="element-70" data-mp="2n42yyyth7vkz">1 intrusion contained</p>
      </div>
    </motion.div>;
}